/* eslint-disable import/no-anonymous-default-export */
import companyRepository from '../repositories/companyRepository'
import { useAppSelector } from '../store/hooks'

function useGetCompany() {
	const {
		auth: { user },
	} = useAppSelector(state => state)

	const { data, isLoading } = companyRepository.useGetQuery({
		companyId: user?.companyId || 0,
	})

	return { data, isLoading }
}

function useGetCompanyMutation() {
	const {
		auth: { user },
	} = useAppSelector(state => state)
	const [_getCompany, { data, isLoading, isSuccess, isError }] =
		companyRepository.useGetMutationMutation()

	async function execute({ companyId }: { companyId?: number }) {
		try {
			let data = undefined

			if (companyId) data = { companyId: companyId }

			if (user?.companyId) data = { companyId: user?.companyId }

			if (data) {
				await _getCompany(data)
			}
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess, isError }
}

export default {
	getCompany: useGetCompany,
	getCompanyMutation: useGetCompanyMutation,
}
